import { fg } from '@atlassian/jira-feature-gating';

export const getWillShowNav4UserOptOutForVisualRefresh = () =>
	// eslint-disable-next-line jira/ff/no-preconditioning
	fg('visual-refresh') && fg('visual-refresh-eap');
